<template>
  <div>
    <el-tooltip effect="light" placement="top">
      <svg class="pie" :height="computedHeight" :width="computedHeight">
        <circle
          v-for="item in dataObjects.slice().reverse()"
          :key="item.key"
          :style="{
            strokeDasharray: `${item.relativeSize} ${circumference}`,
            strokeDashoffset: item.offset,
            strokeWidth: stroke,
          }"
          :r="radius"
          cx="50%"
          cy="50%"
        />
      </svg>
      <template #content>
        <slot name="tooltip" />
      </template>
    </el-tooltip>
  </div>
</template>
<script>
export default {
  name: "PieChart",
  props: {
    size: {
      type: Number,
      default: 0,
    },
    items: {
      type: Array,
      default() {
        return [0];
      },
    },
    minStroke: {
      type: Number,
      default: 2,
    },
    maxStroke: {
      type: Number,
      default: 20,
    },
    minRadius: {
      type: Number,
      default: 16,
    },
    maxRadius: {
      type: Number,
      default: 28,
    },
  },
  data() {
    return {
      hasMounted: false,
    };
  },
  computed: {
    dataTotal() {
      return this.items.reduce(
        (previous, current) => parseInt(previous, 10) + parseInt(current, 10)
      );
    },
    dataObjects() {
      let startingPoint = 0;
      return this.items.map((item) => {
        const relativeSize = (item / this.dataTotal) * (this.circumference) ;
        const dataObject = {
          relativeSize: this.hasMounted ? relativeSize + startingPoint : 0,
          offset: 0,
        };
        startingPoint += relativeSize;
        return dataObject;
      });
    },
    circumference() {
      return 2 * Math.PI * this.radius;
    },
    computedHeight() {
      return 2 * Number(this.radius) + Number(this.stroke);
    },
    radius() {
      const rad = parseInt(this.size, 10) + this.minRadius; // Ensure has min size
      return rad > this.maxRadius ? this.maxRadius : rad; // Ensure radius has sensible max size
    },
    stroke() {
      const stroke = parseInt(this.size, 10) * 2 + this.minStroke; // Ensure has a min size
      return stroke > this.maxStroke ? this.maxStroke : stroke; // Ensure stroke has sensible max size
    },
  },
  mounted() {
    setTimeout(() => {
      this.hasMounted = true;
    }, 0);
  },
  methods: {},
};
</script>

<style lang="scss">
.pie circle {
  fill: none;
  transition: stroke-dasharray 0.4s linear, stroke-dashoffset 0.4s linear;
  transform: rotate(90deg);
  transform-origin: center;
}
// 3rd & 4th colors now set based on PAYM-587 to for applicable date & reporting deadline.
$colors: #37B8CB, #86C79C, #0077c1, #233485, gray, purple;
@for $i from 1 through length($colors) {
  .pie circle:nth-child(#{$i}) {
    stroke: nth($colors, $i);
  }
}
</style>
